export default __webpack_public_path__ + "static/media/gallery05.b35ebcab.webp";